export const PRODUCT_NAME = 'MaviSMART';
